import * as _ from 'lodash';
import Banner from '../generic/Banner';
import useActiveBanners from './useActiveBanners';

/**
 * In charge of rendering all active banners.
 */
const BannerManager = () => {
  const { banners, status, onDismissBanner } = useActiveBanners();
  if (status.loading || status.error) {
    return null;
  }

  return (
    <div className="banner-manager container">
      {banners.map(banner => (
        <Banner
          key={banner.id}
          title={banner.title}
          body={banner.renderedBody}
          bannerStyle={banner.style}
          isDismissible={banner.isDismissible}
          onDismiss={banner.isDismissible ? () => onDismissBanner(banner.id) : _.noop}
        />
      ))}
    </div>
  );
};

export default BannerManager;
